export default __webpack_public_path__ + "static/media/Western Sahara.8682fbc6.png";